var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V496H496V336H16Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V336H496V176H16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V176H496V16H16Z",
    fill: "#F39C12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 326C294.66 326 326 294.66 326 256C326 217.34 294.66 186 256 186C217.34 186 186 217.34 186 256C186 294.66 217.34 326 256 326Z",
    fill: "#000088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 317.25C289.827 317.25 317.25 289.827 317.25 256C317.25 222.173 289.827 194.75 256 194.75C222.173 194.75 194.75 222.173 194.75 256C194.75 289.827 222.173 317.25 256 317.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256 268.25C262.765 268.25 268.25 262.765 268.25 256C268.25 249.235 262.765 243.75 256 243.75C249.235 243.75 243.75 249.235 243.75 256C243.75 262.765 249.235 268.25 256 268.25Z",
    fill: "#000088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M316.326 267.032C318.003 267.253 319.541 266.072 319.762 264.395C319.983 262.718 318.802 261.18 317.125 260.959C315.449 260.739 313.91 261.919 313.689 263.596C313.469 265.273 314.649 266.811 316.326 267.032Z",
    fill: "#000088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256 317.251L258.1 280.501L256 263.001L253.9 280.501L256 317.251Z",
    fill: "#000088"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M311.415 282.269C312.978 282.916 314.769 282.174 315.417 280.612C316.064 279.049 315.322 277.258 313.759 276.61C312.197 275.963 310.405 276.705 309.758 278.268C309.111 279.83 309.853 281.622 311.415 282.269Z",
    fill: "#000088"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M240.147 315.164L251.687 280.209L254.188 262.762L247.63 279.122L240.147 315.164Z",
    fill: "#000088"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M302.728 295.717C304.07 296.746 305.993 296.493 307.022 295.151C308.052 293.81 307.799 291.887 306.457 290.857C305.115 289.828 303.193 290.081 302.163 291.423C301.133 292.765 301.386 294.687 302.728 295.717Z",
    fill: "#000088"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.375 309.045L245.568 278.268L252.5 262.063L241.931 276.168L225.375 309.045Z",
    fill: "#000088"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.857 306.457C291.886 307.799 293.809 308.052 295.151 307.022C296.493 305.993 296.746 304.07 295.716 302.728C294.686 301.387 292.764 301.134 291.422 302.163C290.08 303.193 289.827 305.115 290.857 306.457Z",
    fill: "#000088"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.69 299.31L240.161 274.809L251.05 260.95L237.191 271.839L212.69 299.31Z",
    fill: "#000088"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.61 313.76C277.257 315.323 279.049 316.065 280.611 315.418C282.174 314.77 282.916 312.979 282.269 311.416C281.621 309.854 279.83 309.112 278.267 309.759C276.705 310.406 275.963 312.198 276.61 313.76Z",
    fill: "#000088"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.956 286.625L235.832 270.069L249.938 259.5L233.732 266.432L202.956 286.625Z",
    fill: "#000088"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.958 317.126C261.179 318.803 262.717 319.983 264.394 319.762C266.071 319.542 267.252 318.003 267.031 316.326C266.81 314.649 265.272 313.469 263.595 313.69C261.918 313.911 260.737 315.449 260.958 317.126Z",
    fill: "#000088"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.837 271.853L232.878 264.369L249.238 257.812L231.791 260.313L196.837 271.853Z",
    fill: "#000088"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.969 316.327C244.748 318.004 245.928 319.542 247.605 319.763C249.282 319.983 250.821 318.803 251.041 317.126C251.262 315.449 250.082 313.911 248.405 313.69C246.728 313.469 245.19 314.65 244.969 316.327Z",
    fill: "#000088"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.75 256L231.5 258.1L249 256L231.5 253.9L194.75 256Z",
    fill: "#000088"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229.731 311.416C229.084 312.979 229.826 314.77 231.388 315.417C232.951 316.065 234.743 315.323 235.39 313.76C236.037 312.197 235.295 310.406 233.732 309.759C232.17 309.111 230.378 309.853 229.731 311.416Z",
    fill: "#000088"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.837 240.148L231.791 251.688L249.238 254.189L232.878 247.631L196.837 240.148Z",
    fill: "#000088"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M216.284 302.729C215.254 304.071 215.507 305.994 216.849 307.023C218.191 308.053 220.113 307.8 221.143 306.458C222.173 305.116 221.92 303.194 220.578 302.164C219.236 301.134 217.313 301.387 216.284 302.729Z",
    fill: "#000088"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.956 225.375L233.732 245.569L249.938 252.5L235.832 241.932L202.956 225.375Z",
    fill: "#000088"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205.543 290.858C204.201 291.887 203.948 293.81 204.978 295.152C206.007 296.493 207.93 296.747 209.272 295.717C210.613 294.687 210.866 292.765 209.837 291.423C208.807 290.081 206.885 289.828 205.543 290.858Z",
    fill: "#000088"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M212.69 212.69L237.191 240.161L251.05 251.05L240.161 237.191L212.69 212.69Z",
    fill: "#000088"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.241 276.61C196.678 277.257 195.936 279.049 196.583 280.611C197.23 282.174 199.022 282.916 200.584 282.269C202.147 281.621 202.889 279.83 202.242 278.267C201.595 276.705 199.803 275.963 198.241 276.61Z",
    fill: "#000088"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M225.375 202.956L241.931 235.832L252.5 249.938L245.569 233.732L225.375 202.956Z",
    fill: "#000088"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.874 260.958C193.198 261.179 192.017 262.717 192.238 264.394C192.459 266.071 193.997 267.251 195.674 267.031C197.351 266.81 198.531 265.271 198.31 263.595C198.09 261.918 196.551 260.737 194.874 260.958Z",
    fill: "#000088"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.147 196.836L247.631 232.878L254.188 249.238L251.687 231.791L240.147 196.836Z",
    fill: "#000088"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195.674 244.968C193.997 244.747 192.459 245.928 192.238 247.605C192.017 249.282 193.197 250.82 194.874 251.041C196.551 251.261 198.09 250.081 198.31 248.404C198.531 246.727 197.351 245.189 195.674 244.968Z",
    fill: "#000088"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.749L253.9 231.499L256 248.999L258.1 231.499L256 194.749Z",
    fill: "#000088"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M200.584 229.731C199.022 229.084 197.23 229.826 196.583 231.388C195.936 232.951 196.678 234.742 198.24 235.39C199.803 236.037 201.595 235.295 202.242 233.732C202.889 232.17 202.147 230.378 200.584 229.731Z",
    fill: "#000088"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M271.853 196.836L260.313 231.791L257.812 249.238L264.369 232.878L271.853 196.836Z",
    fill: "#000088"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.271 216.283C207.93 215.254 206.007 215.507 204.977 216.849C203.948 218.19 204.201 220.113 205.543 221.143C206.885 222.172 208.807 221.919 209.837 220.577C210.866 219.235 210.613 217.313 209.271 216.283Z",
    fill: "#000088"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M286.625 202.955L266.431 233.732L259.5 249.937L270.069 235.832L286.625 202.955Z",
    fill: "#000088"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.143 205.543C220.113 204.201 218.191 203.948 216.849 204.978C215.507 206.007 215.254 207.93 216.284 209.272C217.313 210.613 219.236 210.866 220.578 209.837C221.919 208.807 222.173 206.885 221.143 205.543Z",
    fill: "#000088"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31 212.69L271.839 237.191L260.95 251.05L274.809 240.161L299.31 212.69Z",
    fill: "#000088"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M235.39 198.241C234.743 196.678 232.951 195.936 231.389 196.583C229.826 197.231 229.084 199.022 229.731 200.585C230.378 202.147 232.17 202.889 233.732 202.242C235.295 201.595 236.037 199.803 235.39 198.241Z",
    fill: "#000088"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M309.044 225.376L276.168 241.932L262.062 252.501L278.268 245.569L309.044 225.376Z",
    fill: "#000088"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M251.042 194.875C250.821 193.198 249.282 192.018 247.605 192.239C245.929 192.459 244.748 193.998 244.969 195.675C245.19 197.352 246.728 198.532 248.405 198.311C250.082 198.09 251.262 196.552 251.042 194.875Z",
    fill: "#000088"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M315.163 240.148L279.122 247.632L262.761 254.189L280.209 251.688L315.163 240.148Z",
    fill: "#000088"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.031 195.674C267.252 193.997 266.071 192.459 264.394 192.238C262.717 192.018 261.179 193.198 260.958 194.875C260.738 196.552 261.918 198.09 263.595 198.311C265.272 198.532 266.81 197.351 267.031 195.674Z",
    fill: "#000088"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M317.25 256.001L280.5 253.901L263 256.001L280.5 258.101L317.25 256.001Z",
    fill: "#000088"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M282.269 200.585C282.916 199.022 282.174 197.231 280.611 196.584C279.049 195.936 277.257 196.678 276.61 198.241C275.963 199.804 276.705 201.595 278.267 202.242C279.83 202.89 281.621 202.147 282.269 200.585Z",
    fill: "#000088"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M315.163 271.853L280.209 260.313L262.762 257.812L279.122 264.37L315.163 271.853Z",
    fill: "#000088"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M295.716 209.272C296.746 207.93 296.493 206.007 295.151 204.978C293.809 203.948 291.886 204.201 290.857 205.543C289.827 206.885 290.08 208.807 291.422 209.837C292.764 210.867 294.686 210.614 295.716 209.272Z",
    fill: "#000088"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M309.044 286.626L278.267 266.432L262.062 259.501L276.167 270.069L309.044 286.626Z",
    fill: "#000088"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M306.457 221.143C307.799 220.114 308.052 218.191 307.022 216.849C305.993 215.508 304.07 215.254 302.728 216.284C301.386 217.314 301.133 219.236 302.163 220.578C303.193 221.92 305.115 222.173 306.457 221.143Z",
    fill: "#000088"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31 299.311L274.809 271.84L260.95 260.951L271.839 274.81L299.31 299.311Z",
    fill: "#000088"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M313.759 235.391C315.322 234.744 316.064 232.952 315.417 231.39C314.769 229.827 312.978 229.085 311.415 229.732C309.853 230.38 309.111 232.171 309.758 233.734C310.405 235.296 312.197 236.038 313.759 235.391Z",
    fill: "#000088"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M286.625 309.045L270.068 276.169L259.5 262.063L266.431 278.269L286.625 309.045Z",
    fill: "#000088"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M317.125 251.043C318.802 250.822 319.983 249.284 319.762 247.607C319.541 245.93 318.003 244.75 316.326 244.97C314.649 245.191 313.469 246.73 313.689 248.406C313.91 250.083 315.448 251.264 317.125 251.043Z",
    fill: "#000088"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M271.852 315.165L264.369 279.123L257.811 262.763L260.312 280.21L271.852 315.165Z",
    fill: "#000088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.a616d8971299ed98b68b2666518acd87.svg";
export { ForwardRef as ReactComponent };